<script setup lang="ts">
import NavbarComponent from "@/components/NavbarComponent.vue";
import {onMounted, onUnmounted, ref} from "vue";
import SidebarComponent from "@/components/SidebarComponent.vue";
import FooterImpressum from "./components/FooterImpressum.vue";
import "@/assets/styles/main.css"

const isMobile = ref(window.innerWidth <= 768);

const handleResize = () => {
  isMobile.value = window.innerWidth <= 768;
};

onMounted(() => window.addEventListener("resize", handleResize));
onUnmounted(() => window.removeEventListener("resize", handleResize));

</script>

<template>
  <div class="app">
    <!-- Desktop Navbar -->
    <NavbarComponent v-if="!isMobile"/>
    <SidebarComponent v-else/>

    <router-view/>
    
    <FooterImpressum/>
  </div>
</template>
